import { useQuery } from "react-query";

import { useApi } from "../../providers/ApiProvider";
import { APQueryOptions, useAPQuery } from "../../providers/APQueryProvider";
import { VehicleReviewResponse } from "../../types/Vehicles";

export type DossierVehicleReviewFilters = {
  dossierId: string;
  redbookCode: string;
};

export const getDossierVehicleReview = (
  filters: DossierVehicleReviewFilters,
  options: APQueryOptions = {}
) => {
  const { dossierId, ...otherFilters } = filters;
  const { fetchWithAuth } = useApi();
  const { isQueryEnabled, defaultOnMutateError } = useAPQuery();

  return useQuery({
    queryKey: ["dossierVehicleReview", filters],
    queryFn: (): Promise<VehicleReviewResponse> => {
      return fetchWithAuth<VehicleReviewResponse>(
        "getDossierVehicleReview",
        dossierId,
        {
          queryParams: {
            ...otherFilters,
          },
        }
      );
    },
    onError: defaultOnMutateError(options),
    enabled: isQueryEnabled(options),
  });
};
